// @ts-nocheck

import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import useMergeProps from '../../../hooks/useMergeProps';
import RoutesRedirectionFactory from '../../../utils/routes/RoutesRedirectionFactory';
import MPEnrollment from '../components/MPEnrollment';
import { selectIsMPEnabled } from '../selectors/computed/runtime';
import { MPUserStatuses } from '../types/user';

type MPEnrollmentContainerProps = {
  className?: string;
};

const MPEnrollmentContainer = (ownProps: MPEnrollmentContainerProps) => {
  const MPUserStatus = useSelector((state) => state.mp.user?.status);

  const enhancedProps = useMergeProps({ ownProps });

  const isMPEnabled = useSelector(selectIsMPEnabled);

  if (isMPEnabled) {
    if (MPUserStatus && MPUserStatus !== MPUserStatuses.OFF) {
      return <Redirect to={RoutesRedirectionFactory.getMPRoutePathname()} />;
    }

    return <MPEnrollment {...enhancedProps} />;
  }

  return <Redirect to={RoutesRedirectionFactory.getHomeRoutePathname()} />;
};

export default MPEnrollmentContainer;
